import React, { Component } from 'react';
import axios from "axios";
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row, DropdownItem, DropdownMenu, DropdownToggle, ButtonDropdown } from 'reactstrap';
import { Login } from '../../views';
import '../ErrorHandler/errorHandler';
import { bool } from 'prop-types';
import AxiosInstance from '../AxiosInstance/AxiosInstance';

class Language extends Component {

  constructor(props) {

    super(props);
    this.toggle = this.toggle.bind(this);

    this.state = {
      dropdownOpen: new Array(19).fill(false),
      ddlLangList: [],
      ddlLangSelectedText: 'Please Select',
      ddlLangSelectedValue: localStorage.getItem("LanguageCode"),
      IsLogin: false
    };
    this.changeValue = this.changeValue.bind(this);

  }

  toggle(i) {
    const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
    this.setState({
      dropdownOpen: newArray,
    });
  }

  //Change Value
  changeValue(e) {
    this.setState({
      ddlLangSelectedText: e.currentTarget.textContent,
      ddlLangSelectedValue: e.currentTarget.getAttribute("id")
    });
    if (this.state.IsLogin) {
      this.SetDefaultLanguage(e.currentTarget.getAttribute("id"));
    } else {
      this.SetLoginDefaultLanguage(e.currentTarget.getAttribute("id"));
    }
  }

  //SelectLanguageByLangCode
  SelectLanguageByLangCode(langcode1, Islogin) {
    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_c_Language/SelectLanguageByLangCode',
      withCredentials: true,
      errorHandler: true,
      data: {
        langcode: langcode1
      }
    })
      .then(response => {
        localStorage.removeItem("Language");
        localStorage.setItem("Language", JSON.stringify(response.data));
        this.constructor.BindLanguageControl();
      })
      .catch(function (error) {
      });

  }

  /***Before Login***/

  //SetLoginDefaultLanguage
  SetLoginDefaultLanguage(selectedvalue) {

    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_b_UserLanguage/SetLoginDefaultLanguage',
      withCredentials: true,
      errorHandler: true,
      data: {
        selectedvalue: selectedvalue,
        savedb: false
      }
    })
      .then(response => {
        localStorage.removeItem("LanguageCode");
        localStorage.setItem("LanguageCode", selectedvalue);
        this.SelectLanguageByLangCode(selectedvalue, this.state.IsLogin);
      })
      .catch(function (error) {
      });

  }

  //BindLoginDropDownList
  BindLoginDropDownList(control, codetype) {
    var self = this;
    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_c_SysCode/BindLoginDropDownList',
      withCredentials: true,
      errorHandler: true,
      data: {
        control: control,
        codetype: codetype
      }
    })
      .then(response => {
        var i = 0;
        for (i = 0; i < response.data.length; i++) {
          if (response.data[i].codeID == localStorage.getItem("LanguageCode")) {
            self.setState({
              ddlLangSelectedText: response.data[i].codeDesc
            });
          }
        }
        self.setState({
          ddlLangList: response.data
        });

      })
      .catch(function (error) {
      });
  }

  //GetLoginDefaultLanguage
  GetLoginDefaultLanguage() {
    var self = this;
    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_c_SysCode/GetLoginDefaultLanguage',
      withCredentials: true,
      errorHandler: true,
      data: {
        LangCode: localStorage.getItem("LanguageCode")
      }
    })
      .then(response => {
        self.setState({
          ddlLangSelectedValue: response.data
        });
        localStorage.removeItem("LanguageCode");
        localStorage.setItem("LanguageCode", response.data);
        this.SelectLanguageByLangCode(response.data, this.state.IsLogin);
      })
      .catch(function (error) {
      });
  }

  /***After Login***/
  //SetDefaultLanguage
  SetDefaultLanguage(selectedvalue) {

    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_b_UserLanguage/SetDefaultLanguage',
      withCredentials: true,
      errorHandler: true,
      data: {
        selectedvalue: selectedvalue,
        savedb: false
      }
    })
      .then(response => {
        localStorage.removeItem("LanguageCode");
        localStorage.setItem("LanguageCode", selectedvalue);
        this.SelectLanguageByLangCode(selectedvalue, this.state.IsLogin);
      })
      .catch(function (error) {
      });

  }

  //BindDropDownList
  BindDropDownList(control, codetype) {
    var self = this;
    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_c_SysCode/BindDropDownList',
      withCredentials: true,
      errorHandler: true,
      data: {
        control: control,
        codetype: codetype
      }
    })
      .then(response => {
        var i = 0;
        for (i = 0; i < response.data.length; i++) {
          if (response.data[i].codeID == self.state.ddlLangSelectedValue) {
            self.setState({
              ddlLangSelectedText: response.data[i].codeDesc
            });
          }
        }
        self.setState({
          ddlLangList: response.data
        });

      })
      .catch(function (error) {
      });
  }

  //GetDefaultLanguage
  GetDefaultLanguage() {
    var self = this;
    AxiosInstance({
      method: 'Post',
      url: 'tbSYS_c_SysCode/GetDefaultLanguage',
      withCredentials: true,
      errorHandler: true,
      data: {
        LangCode: localStorage.getItem("LanguageCode")
      }
    })
      .then(response => {
        self.setState({
          ddlLangSelectedValue: response.data
        });
        localStorage.removeItem("LanguageCode");
        localStorage.setItem("LanguageCode", response.data);
        this.SelectLanguageByLangCode(response.data, this.state.IsLogin);
      })
      .catch(function (error) {
      });
  }

  //BindLanguageControl
  static BindLanguageControl() {

    var data = JSON.parse(localStorage.getItem("Language"));

    const reacttag = document.querySelectorAll('*');

    var i = 0;
    var y = 0;
    for (i = 0; i < reacttag.length; i++) {
      if (reacttag[i].getAttribute('data-langid') != null && data != null) {

        data.filter(el => el.tbSYScLanguageID == reacttag[i].getAttribute('data-langid')).map(e => {
          if (reacttag[i].getAttribute('placeholder') != null) {
            reacttag[i].attributes.placeholder.value = e.value;
          } else {
            reacttag[i].textContent = e.value;
          }
        });
        //var IsExists = false;

        //IsExists = data.some(function (el) {
        //  return el.tbSYScLanguageID == reacttag[i].getAttribute('data-langid');
        //});
        ////If Language not Exists, will Insert into Database
        //if (!IsExists) {
        //  AxiosInstance({
        //    method: 'Post',
        //    url: 'tbSYS_c_Language/InsertLanguage',
        //    withCredentials: true,
        //    errorHandler: true,
        //    data: {
        //      tbSYScLanguageID: reacttag[i].getAttribute('data-langid'),
        //      predefined: reacttag[i].textContent
        //    }
        //  })
        //    .then(response => {
        //      //Update the IndexedDB Language ObjectStore
        //      AxiosInstance({
        //        method: 'Post',
        //        url: 'tbSYS_c_Language/SelectLanguageByLangCode',
        //        withCredentials: true,
        //        errorHandler: true,
        //        data: {
        //          langcode: localStorage.getItem("LanguageCode")
        //        }
        //      })
        //        .then(response => {
        //          if (response != undefined) {
        //            localStorage.removeItem("Language");
        //            localStorage.setItem("Language", JSON.stringify(response.data));
        //          }

        //        })
        //        .catch(function (error) {
        //        });
        //    })
        //    .catch(function (error) {
        //    });
        //}


      }
    }
  }


  ValidateToken() {
    var self = this;
    if (localStorage.getItem("accessToken") !== null) {
      self.setState({
        IsLogin: true
      });
    } else {
      self.setState({
        IsLogin: false
      });
    }
  }

  componentDidMount() {
    this.ValidateToken();

    if (this.state.IsLogin) {
      this.GetDefaultLanguage();
      this.BindDropDownList('ddlLang', 'LANGUAGE');
    } else {
      this.GetLoginDefaultLanguage();
      this.BindLoginDropDownList('ddlLang', 'LANGUAGE');
    }
  }

  //Get Language from local storage by Language ID
  static GetLanguageByID(id) {
    var y = 0;
    var data = JSON.parse(localStorage.getItem("Language"));
    for (y = 0; y < data.length; y++) {
      if (id == data[y].tbSYScLanguageID) {
        return data[y].value != '' ? data[y].value : '';
      }
    }
  }

  render() {
    return (<ButtonDropdown className="mr-1 ddlLanguage" isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }} >
      <DropdownToggle color="none" className="btn-language" caret > {this.state.ddlLangSelectedText}</DropdownToggle>
      <DropdownMenu right>
        {this.state.ddlLangList.map(e => {
          return <DropdownItem color="none"  className="btn-language" id={e.codeID} key={e.codeID} onClick={this.changeValue}>{e.codeDesc}</DropdownItem>
        })}
      </DropdownMenu>
    </ButtonDropdown>);

  }

}


export default Language;
